import { Css, useTestIds } from "@homebound/beam";
import { camelCase } from "change-case";
import { ReactNode } from "react";

export type StatTotalsItem = {
  value: ReactNode;
  label: string;
  /** The value's test id suffix. Defaults to the camelCased label. */
  testId?: string;
};

type StatTotalsProps = {
  items: StatTotalsItem[];
  /** The root test id, which each value's test id hangs off. Defaults to `statTotals`. */
  testId?: string;
};

/** A row of equal-width stats in one bordered box: a big value over its small label. The caller colors the value. */
export function StatTotals(props: StatTotalsProps) {
  const { items, testId = "statTotals" } = props;
  const tid = useTestIds(props, testId);
  return (
    <div css={Css.df.ba.bcGray200.br8.$} {...tid}>
      {items.map((item, i) => (
        <div key={item.label} css={Css.df.fdc.aic.p2.fg1.if(i < items.length - 1).br.bcGray200.$}>
          <span css={Css.xl.$} {...tid[item.testId ?? camelCase(item.label)]}>
            {item.value}
          </span>
          <span css={Css.sm.gray700.$}>{item.label}</span>
        </div>
      ))}
    </div>
  );
}
